import { BasicEntity } from 'netsocial-lib/src/app/interfaces/basic-entity';
import { User } from 'netsocial-lib/src/app/interfaces/user';
import { Badge } from 'netsocial-lib/src/app/interfaces/badge';
import { PerformanceStatistics } from './performance-statistics';

export class LeaderboardEntry extends BasicEntity {
  public profile: User;
  public order: number;
  public statistics: PerformanceStatistics;
  public badges: Badge[];

  constructor(leaderboard: Partial<LeaderboardEntry>) {
    super(leaderboard);

    this.profile = new User(leaderboard.profile);
    this.statistics = new PerformanceStatistics(leaderboard.statistics);
    this.badges = (leaderboard.badges ?? []).map((badge) => new Badge(badge));
  }
}
